import React from "react";
import { Video, Clapperboard, Building2, GraduationCap, Megaphone } from 'lucide-react';
import {
  leftTopArrowGradient,
  rightBottomArrowGradient,
  purpleCircleGradient,
  orangeCircleGradient,
  skincolorCircleGradient,
  greenCircleGradient,
} from "@/assets/svgs/gradientIcons";

import { TwinneeLogo } from '@/components/TwinneeLogo';
export const WhoItIsFor = () => {
  const cards = [
    {
      icon: Video,
      title: "Content creators",
      description: "Batch shorts, explainers, and serialized posts with consistent characters and a scene-native timeline.",
      glowColor: "from-purple-600/30 via-indigo-900/15",
      iconColor: "#D0BCFF",
      circleGradient: purpleCircleGradient,
      bgImage: "/LandingPageAssets/content-creator.png",
    },
    {
      icon: Clapperboard,
      title: "Movie creators",
      description: "Draft stories, generate shots per scene, and iterate with Director AI—without losing narrative structure.",
      glowColor: "from-amber-600/30 via-orange-900/15",
      iconColor: "#FFAA6C",
      circleGradient: orangeCircleGradient,
      bgImage: "/LandingPageAssets/movie-creator.png",
    },
    {
      icon: TwinneeLogo,
      title: "Influencers",
      description: "Spin up polished promo clips and story-driven ads that match your brand tone in minutes, not days.",
      glowColor: "from-rose-600/30 via-pink-900/15",
      iconColor: "#FF8DA1",
      circleGradient: skincolorCircleGradient,
      bgImage: "/LandingPageAssets/influencer.png",
    },
    {
      icon: Building2,
      title: "Corporate storytelling",
      description: "Product launches, internal comms, and brand films—script to screen with approvals-friendly scene cuts.",
      glowColor: "from-teal-600/30 via-emerald-900/15",
      iconColor: "#62FAE3",
      circleGradient: greenCircleGradient,
      bgImage: "/LandingPageAssets/corporate-storytelling.png",
    },
    {
      icon: GraduationCap,
      title: "Trainers",
      description: "Build lesson modules as scenes—narration, on-screen text, and regen per beat for faster course updates.",
      glowColor: "from-purple-600/30 via-indigo-900/15",
      iconColor: "#D0BCFF",
      circleGradient: purpleCircleGradient,
      bgImage: "/LandingPageAssets/trainers.png",
    },
    {
      icon: Megaphone,
      title: "Ad agencies",
      description: "Pitch concepts with real motion, swap providers per shot, and ship client cuts from one workspace.",
      glowColor: "from-teal-600/30 via-emerald-900/15",
      iconColor: "#62FAE3",
      circleGradient: greenCircleGradient,
      bgImage: "/LandingPageAssets/adagencies.png",
    },
  ];

  return (
    <section id="who-it-is-for" className="text-white py-24 px-4 sm:px-6 lg:px-8 font-sora relative">
      <div
        className="absolute -top-24 -left-24 w-[650px] md:w-[950px] h-auto pointer-events-none z-0 opacity-100"
        dangerouslySetInnerHTML={{ __html: leftTopArrowGradient }}
      />
      <div
        className="absolute -bottom-64 -right-16 md:-bottom-80 md:-right-20 w-[650px] md:w-[950px] h-auto pointer-events-none z-0 opacity-100"
        dangerouslySetInnerHTML={{ __html: rightBottomArrowGradient }}
      />

      <div className="max-w-6xl mx-auto text-center relative z-10">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight uppercase">
          WHO <span className="bg-gradient-to-r from-[#D0BCFF] to-[#62FAE3] bg-clip-text text-transparent">THIS IS FOR?</span>
        </h2>
        <p className="mt-4 text-gray-400 text-sm md:text-base max-w-2xl mx-auto font-normal">
          From solo creators to agency teams—Twinnee fits the way you already tell stories on screen.
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
          {cards.map((card, index) => {
            const Icon = card.icon;
            return (
              <div
                key={index}
                className="relative group rounded-[20px] border border-white/10 bg-[#0a0d14]/75 backdrop-blur-xl p-8 sm:p-9 overflow-hidden transition-all duration-300 hover:border-white/25 hover:bg-[#0e121d]/85 min-h-[290px] sm:min-h-[310px] flex flex-col justify-end"
              >
                {card.bgImage && (
                  <img
                    src={`${process.env.PUBLIC_URL || ""}${card.bgImage}`}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover pointer-events-none opacity-50 group-hover:opacity-75 transition-opacity duration-300 z-0"
                  />
                )}
                {/* Gradient Circles & Glows - Hidden for now */}
                {/* {card.circleGradient && (
                  <div
                    className="absolute -top-10 -right-10 w-52 h-52 pointer-events-none opacity-90 group-hover:opacity-100 transition-opacity duration-300 z-0"
                    dangerouslySetInnerHTML={{ __html: card.circleGradient }}
                  />
                )}
                <div
                  className={`absolute -top-16 -right-16 w-64 h-64 bg-gradient-to-bl ${card.glowColor} to-transparent rounded-full blur-3xl pointer-events-none opacity-80 group-hover:opacity-100 transition-opacity z-0`}
                /> */}
                <div className="relative z-10 flex flex-col justify-end">
                  <div>
                    {/* Icon - Hidden for now */}
                    {/* <div className="w-11 h-11 rounded-xl bg-white/[0.04] border border-white/10 flex items-center justify-center mb-6 group-hover:border-white/25 transition-colors">
                      <Icon className="w-5 h-5" style={{ color: card.iconColor }} />
                    </div> */}
                    <h3 className="text-xl sm:text-[22px] font-semibold text-white mb-3 tracking-tight">{card.title}</h3>
                    <p className="text-gray-300/90 text-sm leading-relaxed font-normal">{card.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhoItIsFor;
